export default __webpack_public_path__ + "static/media/salary.6fa51e70.svg";